/**
 * Puente cross-chain del ecosistema Infinite Drive.
 * Override en `.env`: `VITE_BRIDGE_URL`.
 */
export const BRIDGE_SITE_URL =
  import.meta.env.VITE_BRIDGE_URL?.trim() || 'https://bridge.zaphod.one'

export const BRIDGE_SITE_LINK_PROPS = {
  href: BRIDGE_SITE_URL,
  target: '_blank',
  rel: 'noopener noreferrer',
} as const
